import { render, staticRenderFns } from "./SuppliesShop.vue?vue&type=template&id=c60b950c"
import script from "./SuppliesShop.vue?vue&type=script&lang=js"
export * from "./SuppliesShop.vue?vue&type=script&lang=js"
import style0 from "./SuppliesShop.vue?vue&type=style&index=0&id=c60b950c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports